module.exports = "https://static.wmbcdn.com/uniweb/images/a880316fec7fb522f37dfc5c3485f059.svg";